import { ComponentProps, ReactNode } from 'react';
import Link from 'next/link';

export function ConditionLink(props: { children?: ReactNode; href?: string } & ComponentProps<typeof Link>) {
  const { children, href, ...restProps } = props;
  if (href) {
    return (
      <Link href={href} passHref {...restProps} legacyBehavior>
        {children}
      </Link>
    );
  }
  return <div>{children}</div>;
}
